<template>
  <div class="input-container">
    <label :for="componentID" class="label">{{ labelText }}</label>
    <input class="input" type="text" :id="componentID" />
  </div>
</template>

<script>
export default {
  props: ["componentID", "labelText"]
};
</script>

<style scoped>
.input-container {
  display: flex;
  flex-direction: column;
}

.label {
  font-size: 13px;
  color: #acb5c5;
}

.input {
  margin-top: 5px;
  border: 1px solid #acb5c5;
  border-radius: 5px;
  outline: none;
}
</style>
